export enum EquipementTemperaturesFilter {
  Fridges,
  Deliveries,
  Oils,
}
